<!-- Modern Debug Dialog -->
<div class="debug-dialog-container">
    <!-- Header with blue accent line -->
    <div class="section-header" mat-dialog-title>
        <mat-icon class="section-icon">bug_report</mat-icon>
        <span class="section-title">{{ data.title }}</span>
        <button mat-icon-button class="ss-dialog-close-btn" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Statistics Bar -->
    <div class="stats-bar">
        <div class="stat-item">
            <mat-icon>format_list_numbered</mat-icon>
            <span>{{ messageCount }} messages</span>
        </div>
        <div class="stat-item">
            <mat-icon>timer</mat-icon>
            <span>{{ elapsedTime }}</span>
        </div>
        <div class="stat-item">
            <mat-icon>text_fields</mat-icon>
            <span>{{ charCount.toLocaleString() }} chars</span>
        </div>
        <div class="stat-item">
            <mat-icon>notes</mat-icon>
            <span>{{ lineCount }} lines</span>
        </div>
    </div>

    <!-- Debug Text Area -->
    <div mat-dialog-content class="debug-content">
        <textarea
            id="debugTextarea"
            class="debug-textarea"
            [(ngModel)]="debugText"
            spellcheck="false"
            readonly></textarea>
    </div>

    <!-- Action Buttons -->
    <div mat-dialog-actions class="debug-actions">
        <button mat-raised-button color="primary" (click)="copyToClipboard()">
            <mat-icon>content_copy</mat-icon>
            copy to clipboard
        </button>

        <button mat-raised-button (click)="downloadLogs()">
            <mat-icon>download</mat-icon>
            download as file
        </button>

        <div class="spacer"></div>

        <button mat-raised-button (click)="close()">
            <mat-icon>close</mat-icon>
            close
        </button>
    </div>
</div>
